import { Box, Heading, Section, Stack, Text } from "@vinomofo/components";
import { useEffect, useRef, useState } from "react";

import { OfferHeroCard } from "./OfferHeroCard";
import { VinoDataOffer } from "../../types/vino-data-types";
import { OfferDetailsGiftCardProps } from "../offer-details/OfferDetailsGiftCard";

export interface OfferHeroGCProps {
  details: OfferDetailsGiftCardProps;
  offer: VinoDataOffer;
}

export const OfferHeroGiftCard = ({
  details,
  offer,
}: OfferHeroGCProps): JSX.Element => {
  const {
    productId,
    endsAt,
    price,
    unitRRP,
    priceDescription,
    shortDescription,
    showPriceDrop,
    showCountdown,
    urgencyMessage,
    isSoldOut,
    name,
  } = details;

  const sectionRef = useRef<HTMLElement>(null);
  const heroImageRef = useRef<HTMLElement>(null);

  const [imageHeight, setImageHeight] = useState(0);

  useEffect(() => {
    if (heroImageRef.current) setImageHeight(heroImageRef.current.clientHeight);
  }, [heroImageRef?.current?.clientHeight]);

  return (
    <Section ref={sectionRef} minHeight={imageHeight + 150}>
      <Box display={["block", "block", "flex"]} justifyContent="flex-end">
        <Box
          flexBasis={["100%", "100%", "31.034%"]}
          maxWidth={["100%", "100%", "360px"]}
          paddingTop={[0, 0, "80px"]}
          mb={0}
          minHeight={["auto", "auto", 875]}
        >
          <OfferHeroCard
            productId={productId}
            shortDescription={shortDescription}
            price={price}
            rrp={offer.is_wine ? unitRRP : null}
            priceDescription={priceDescription}
            region={null}
            style={null}
            endsAt={endsAt}
            showCountdown={showCountdown}
            showPriceDrop={showPriceDrop}
            urgencyMessage={urgencyMessage}
            isSoldOut={isSoldOut}
            name={name}
            offer={offer}
            hideIconVarietal={true}
          />
        </Box>
      </Box>
    </Section>
  );
};
